import React, { useState, useEffect } from "react";

import {
	Flex,
	Stack,
	Image,
	ModalHeader,
	ModalFooter,
	ModalContent,
	ModalOverlay,
	ModalCloseButton,
	ModalBody,
	Modal,
	Heading,
	Link,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	Box,
	AccordionIcon,
} from "@chakra-ui/react";
import Intro from "./components/utils/Intro";
import Login from "./components/utils/Login";
import AdminHome from "./components/AdminSection/AdminHome";
import UserHome from "./components/UserSection/UserHome";
import { useGetParams } from "./data/useGetParams";
import faqLogo from "./img/faqLogo.png";
import SupervisorCounters from "./components/utils/SupervisorCounters";

const initialSupervisorData = {
	isSupervisor: false,
	user: {},
};

function App() {
	const [showIntro, setShowIntro] = useState(true);
	const [userLogged, setUserLogged] = useState(false);
	const [supervisorData, setSupervisorData] = useState(initialSupervisorData);
	const [faqModalOpen, setFaqModalOpen] = useState(false);

	const { data: parameters, refetch: refetchParams } = useGetParams();

	useEffect(() => {
		setUserLogged(null);
		setSupervisorData(initialSupervisorData);
		setTimeout(() => {
			setShowIntro(false);
		}, 5000);
	}, []);

	const closeSession = () => {
		setUserLogged(null);
	};

	const [showMarquee, setShowMarquee] = useState(true);

	const hasPreguntas = parameters?.preguntas && parameters.preguntas.length > 0;

	return showIntro || !parameters ? (
		<Intro />
	) : !userLogged ? (
		<>
			<Login
				supervisorData={supervisorData}
				setUserLogged={setUserLogged}
				params={parameters}
				setSupervisorData={setSupervisorData}
			/>{" "}
			{hasPreguntas && (
				<>
					<Flex position="fixed" bottom="5px" right="5px" alignItems="flex-end">
						<Image
							onClick={() => setFaqModalOpen(true)}
							w="50px"
							h="50px"
							src={faqLogo}
						/>
					</Flex>
					<Modal
						isOpen={faqModalOpen}
						onClose={() => {
							setFaqModalOpen(false);
						}}
					>
						<ModalOverlay padding={5}>
							<ModalContent marginTop="5vh" minH="300px" marginX={5}>
								<ModalCloseButton />
								<ModalHeader
									borderRadius="0.375rem 0.375rem 0 0"
									display="flex"
									justifyContent="center"
									bg="#F6D300"
								>
									<Heading size="lg">{parameters.preguntas_cabecera}</Heading>
								</ModalHeader>
								<ModalBody
									display="flex"
									flexDirection="column"
									alignItems="center"
									textAlign="center"
									height="100%"
								>
									<Accordion w="100%" allowMultiple defaultIndex={[]}>
										{parameters.preguntas?.map((preg, i) => {
											return (
												preg.numero !== "0" &&
												preg.numero !== "999" && (
													<AccordionItem key={i}>
														<h2>
															<AccordionButton>
																<Box fontWeight="600" flex="1" textAlign="left">
																	{preg.pregunta}
																</Box>
																<AccordionIcon />
															</AccordionButton>
														</h2>
														<AccordionPanel textAlign="start" pb={4}>
															{preg.respuesta}

															{preg.vinculo && (
																<div>
																	<Link
																		color="#4286f4"
																		href={`./${preg.vinculo}`}
																		target="_blank"
																	>
																		Acceda al formulario desde aquí
																	</Link>
																</div>
															)}
														</AccordionPanel>
													</AccordionItem>
												)
											);
										})}
									</Accordion>
								</ModalBody>
								<ModalFooter
									borderRadius="0 0 0.375rem 0.375rem"
									display="flex"
									justifyContent="center"
									bg="#F6D300"
								>
									<Heading textAlign="center" size="sm">
										{parameters.preguntas_pie}
									</Heading>
								</ModalFooter>
							</ModalContent>
						</ModalOverlay>
					</Modal>
				</>
			)}
		</>
	) : (
		<Flex
			direction="column"
			h="100vh"
			maxW="100vw"
			bg="#e3e4e6"
			className="App"
		>
			{supervisorData.isSupervisor && (
				<>
					<Stack
						color="#fed700"
						position={"absolute"}
						left="5"
						gap={0}
						alignItems={"center"}
					>
						<Heading fontSize={"20px"} m={0}>
							SUPERVISOR
						</Heading>
						<Flex>{supervisorData.user.documento}</Flex>
					</Stack>
					<SupervisorCounters
						contador1_numero={parameters?.contador1_numero}
						contador1_titulo={parameters?.contador1_titulo}
						contador2_numero={parameters?.contador2_numero}
						contador2_titulo={parameters?.contador2_titulo}
						contador3_numero={parameters?.contador3_numero}
						contador3_titulo={parameters?.contador3_titulo}
					/>
				</>
			)}
			<Flex
				w={"100%"}
				bg="#555"
				color="#fafafa"
				justifyContent={"center"}
				p={3}
			>
				{parameters?.titulo_web}
			</Flex>{" "}
			{false ? (
				<AdminHome />
			) : (
				<UserHome
					supervisorData={supervisorData}
					userData={userLogged}
					remeraOptions={parameters.remera_talles}
					remeraImage={parameters.remera_imagen}
					adminCellCode={parameters.codigo_celular}
					closeSession={closeSession}
					params={parameters}
					refetchParams={refetchParams}
				/>
			)}
			{hasPreguntas && (
				<>
					<Modal
						isOpen={faqModalOpen}
						onClose={() => {
							setFaqModalOpen(false);
						}}
					>
						<ModalOverlay padding={5}>
							<ModalContent marginTop="5vh" minH="300px" marginX={5}>
								<ModalCloseButton />
								<ModalHeader
									borderRadius="0.375rem 0.375rem 0 0"
									display="flex"
									justifyContent="center"
									bg="#F6D300"
								>
									<Heading size="lg">{parameters.preguntas_cabecera}</Heading>
								</ModalHeader>
								<ModalBody
									display="flex"
									flexDirection="column"
									alignItems="center"
									textAlign="center"
									height="100%"
								>
									<Accordion w="100%" allowMultiple defaultIndex={[]}>
										{parameters.preguntas?.map((preg, i) => {
											return (
												preg.numero !== "0" &&
												preg.numero !== "999" && (
													<AccordionItem key={i}>
														<h2>
															<AccordionButton>
																<Box fontWeight="600" flex="1" textAlign="left">
																	{preg.pregunta}
																</Box>
																<AccordionIcon />
															</AccordionButton>
														</h2>
														<AccordionPanel textAlign="start" pb={4}>
															{preg.respuesta}

															{preg.vinculo && (
																<div>
																	<Link
																		color="#4286f4"
																		href={`./${preg.vinculo}`}
																		target="_blank"
																	>
																		Acceda al formulario desde aquí
																	</Link>
																</div>
															)}
														</AccordionPanel>
													</AccordionItem>
												)
											);
										})}
									</Accordion>
								</ModalBody>
								<ModalFooter
									borderRadius="0 0 0.375rem 0.375rem"
									display="flex"
									justifyContent="center"
									bg="#F6D300"
								>
									<Heading textAlign="center" size="sm">
										{parameters.preguntas_pie}
									</Heading>
								</ModalFooter>
							</ModalContent>
						</ModalOverlay>
					</Modal>
					<Flex position="fixed" bottom="5px" right="5px" alignItems="flex-end">
						<Image
							onClick={() => setFaqModalOpen(true)}
							w="50px"
							h="50px"
							src={faqLogo}
						/>
					</Flex>
				</>
			)}
		</Flex>
	);
}

export default App;
